<template>
  <v-container grid-list-lg fluid v-if="selectedBatch">
    <v-layout row align-center>
      <v-flex shrink>
        <v-btn small rounded text @click.stop.prevent="$router.go(-1)">
          <v-icon left>mdi-chevron-left </v-icon>
          <span class="hidden-sm-and-down">Batch Selection</span>
        </v-btn>
      </v-flex>
      <v-spacer></v-spacer>
      <v-flex shrink class="title text-right">
        Batch Report
      </v-flex>
    </v-layout>

    <v-layout row wrap v-if="selectedBatch">
      <v-flex shrink >
      <v-expand-transition>
         <v-avatar v-if="light.length" size="80" :color="light[0].LightStatus.toLowerCase()">
        </v-avatar>
      </v-expand-transition>
       
      </v-flex>
      <v-flex>
        <div class="text-center text-h4">Batch Report</div>
        <div class="text-center">{{ selectedBatch.OpenDate | moment("MM/DD/YYYY") }} - {{ selectedBatch.CloseDate |
            moment("MM/DD/YYYY")
        }}</div>
        <div class="text-center text-capitalize text--disabled font-italic">{{ selectedBatch.OpenEmployeeName }} - {{
            selectedBatch.CloseEmployeeName
        }}</div>
      </v-flex>
    </v-layout>

<v-expand-transition>
  <v-card-text v-if="sales">
      <v-layout column>
        <v-flex v-for="(sale, index) in sales" :key="index">
          <v-chip label>{{ sale[0].GroupHeading }}</v-chip>
          <v-list>
            <div v-for="(detail, i) in sale" :key="i">
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title v-text="detail.Description"></v-list-item-title>
                </v-list-item-content>

                <v-list-item-action>
                  {{ detail.Amount | currency }}
                </v-list-item-action>
              </v-list-item>
              <v-divider v-if="i + 1 < sale.length" :key="i"> </v-divider>
            </div>
          </v-list>
        </v-flex>
      </v-layout>
    </v-card-text>
</v-expand-transition>
    
    <v-card-text v-if="!sales">
      <v-progress-linear :indeterminate="true"></v-progress-linear>
    </v-card-text>




  </v-container>


</template>

<script>
import reportService from '@/pages/Report/service.js'

export default {
  name: 'batch-report',
  data() {
    return {
      light: false,
      selectedBatch: null,
      Batch: null,
      sales: null,
    }
  },
  created() {
    // console.log('this.$route.params', this.$route.params)
    if (!this.$route.params.batch) {
      this.$router.push({ name: "report-dashboard" });
    } else {
      this.selectedBatch = this.$route.params.batch
      this.getBatch()
      this.getLightStatus()
    }

  },
  methods: {
    getBatch() {
      return reportService
        .getBatch(this.selectedBatch.StoreID, { batchId: this.selectedBatch.BatchID })
        .then(response => {
          this.Batch = response.data
          // console.log("Batchs", this.Batch);
          if (this.Batch.length) {
            this.sales = _.mapValues(
              _.groupBy(this.Batch, row => row.HeadingID),
              list => {
                return list;
              }
            );
          }

          return response;
        });
    },
    getLightStatus() {
      return reportService
        .getLightStatus(this.selectedBatch.StoreID, { batchId: this.selectedBatch.BatchID })
        .then(response => {
          this.light = response.data
          console.log("Batchs", response);

          return response;
        });
    }
  }
}
</script>

<style scoped>
</style>